import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchInputAreaDefaultBox} from "./search-input-area.default.box";
import {SearchInputAreaCasino777Box} from "./search-input-area.casino777.box";
import {SearchInputArenaHarrahsBox} from "./search-input-area.harrahs.box";
import {SearchInputAreaCasino888Box} from "./search-input-area.casino888.box";
import {SearchInputAreaBallysDoverBox} from "./search-input-area.ballysdover.box";
import {SearchInputAreaDelawareParkBox} from "./search-input-area.delawarepark.box";
import {SearchInputAreaHarringtonBox} from "./search-input-area.harrington.box";
import {SearchInputArenaSIBox} from "./search-input-arena.si.box";


export const SearchInputAreaBox = styledByTheme(SearchInputAreaDefaultBox)
    .forCasino888(SearchInputAreaCasino888Box)
    .forCasino777(SearchInputAreaCasino777Box)
    .forHarrahs(SearchInputArenaHarrahsBox)
    .forBallysDover(SearchInputAreaBallysDoverBox)
    .forDelawarePark(SearchInputAreaDelawareParkBox)
    .forHarrington(SearchInputAreaHarringtonBox)
    .forSI(SearchInputArenaSIBox)
    .apply();
